import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {NgxCurrencyModule} from "ngx-currency";
import {MaterialCommonModule} from "src/app/material-modules/material-common.module";
import {CadastrarAcaoExecutadaComponent} from "./cadastrar-acao-executada/cadastrar-acao-executada.component";
import {AcaoExecutadaRoutingModule} from "./acao-executada-routing.module";
import {AcaoExecutadaComponent} from "./acao-executada.component";
import {ComboPesquisavelModule} from "../common/combo-pesquisavel/combo-pesquisavel.module";
import {ComboProgramaModule} from "../common/combo-programa/combo-programa.module";
import {ComboEmpresaModule} from "../common/combo-empresa/combo-empresa.module";
import {ComboProjetoModule} from "../common/combo-projeto/combo-projeto.module";
import {ComboFuncionarioModule} from "../common/combo-funcionario/combo-funcionario.module";
import {FormularioFrequenciaComponent} from "./formulario-frequencia/formulario-frequencia.component";
import {FormularioColaboradorComponent} from "./formulario-colaborador/formulario-colaborador.component";
import {FormularioMetasComponent} from "./formulario-metas/formulario-metas.component";
import {ComboMetaAcaoModule} from "../common/combo-meta-acao/combo-meta-acao.module";
import {ComboBeneficiarioModule} from "../common/combo-beneficiario/combo-beneficiario.module";
import {ComboAtividadeModule} from "../common/combo-atividade/combo-atividade.module";
import {ComboAcaoAtividadeModule} from "../common/combo-acao-atividade/combo-acao-atividade.module";

@NgModule({
    declarations: [
        AcaoExecutadaComponent,
        CadastrarAcaoExecutadaComponent,
        FormularioFrequenciaComponent,
        FormularioColaboradorComponent,
        FormularioMetasComponent
    ],
    imports: [
        CommonModule,
        NgxCurrencyModule,
        MaterialCommonModule,
        AcaoExecutadaRoutingModule,
        ComboPesquisavelModule,
        ComboProgramaModule,
        ComboEmpresaModule,
        ComboProjetoModule,
        ComboFuncionarioModule,
        ComboMetaAcaoModule,
        ComboBeneficiarioModule,
        ComboAtividadeModule,
        ComboAcaoAtividadeModule
    ],
})
export class AcaoExecutadaModule {
}
